import Global from '/js/core/global.js';
import UserLessons from '/js/core/user-lessons.js';
import AppUtil from '/js/util/app-util.js';
import Util from "/js/util/util.js";

/**
 *
 */
export default class CardsHolderViewUtil {

  /**
   * Returns a stack index and card index in an array.
   */
  static getInitialStackCardIndex(alwaysFromStart) {
    // Special dev interaction param
    let devCoords = this.#getStackCardIndexForDevIxParam();
    if (devCoords) {
      return devCoords;
    }
    // Special dev stack/card params
    devCoords = this.#getStackCardIndexForDevStackCardParams();
    if (devCoords) {
      return devCoords;
    }

    if (alwaysFromStart) {
      return [0, 0];
    }

    // Minicourse saved user progress
    if (Global.minicourseData) {
      if (UserLessons.current.isComplete) {
        return [0, 0];
      }
      const absIndex = UserLessons.current.index;
      if (!isNaN(absIndex)) {
        const [stackIndex, cardIndex]
            = AppUtil.absoluteIndexToStackAndCardIndex(Global.lessonData, absIndex);
        // cl("abs index", absIndex, "=", "stack index", stackIndex, "card index", cardIndex);
        return [stackIndex, cardIndex];
      }
    }

    // Default
    return [0, 0];
  }

  /** Returns [stackIndex, cardIndex] or null. */
  static #getStackCardIndexForDevIxParam() {
    const ixCode = Util.getParameterByName("ix", window.location);
    if (!ixCode) {
      return null;
    }
    let count = 0;
    let result = null;
    const stacks = Global.lessonData.stacks;
    stacks.forEach((stack, i) => {
      stack.cards.forEach((card, j) => {
        if (card.layout === "interaction") {
          count++;
          switch (ixCode) {
            case "first":
              if (count === 1) {
                result = [i, j];
                break;
              }
              break;
            case "middle":
              if (count === 2) {
                result = [i, j];
                break;
              }
              break;
            case "last":
              result =  [i, j];
              break;
          }
        }
      }, this);
    }, this);

    return result;
  }

  /** Returns [stackIndex, cardIndex] or null. */
  static #getStackCardIndexForDevStackCardParams() {
    let stack = Util.getParameterByName("stack", window.location);
    stack = parseInt(stack);
    if (isNaN(stack)) {  // Stack value is required.
      return null;
    }
    let card = Util.getParameterByName("card", window.location);
    card = parseInt(card) || 0;  // Card value is optional.
    return [stack, card];
  }
}